import React from 'react'
import './service.css'
import Images from "../../data/Images";
import Seperator from '../../Common/Seperator/Seperator'

const Service = () => {
  return (
    <div className='service'>
        <div className="s-content">
        <div data-aos="fade-up" className="c-title"><Seperator/> <h2>My Services</h2> <Seperator/></div>
            <div data-aos="fade-up" className='s-title'>What I Do</div>
        </div>

        <div className="service-rec">
        <div data-aos="fade-right" className="rec">
            <div className="icon">
               <span className='icons'> <img src={Images.Web} alt="" /> </span>
            </div>
            <div className="cont">
               <div> <h2>Web <br/> Developer.</h2> </div>
               <div> <span>12+ Projects</span> </div>
            </div>
        </div>
        <div data-aos="fade-right" className="rect">
        <div className="icon">
                <span className='icons'> <img src={Images.Graphic} alt="" /> </span>
            </div>
            <div className="cont-rec">
                <h2>Graphic <br/> Designer.</h2>
                <span>40+ Projects</span>
            </div>
        </div>
        <div data-aos="fade-left" className="rec">
        <div className="icon">
        <span className='icons'> <img src={Images.Ux} alt="" /> </span>
            </div>
            <div className="cont">
                <h2>Ux/Ui <br/> Designer.</h2>
                <span>10+ Projects</span>
            </div>
        </div>
        <div data-aos="fade-left" className="rect">
        <div className="icon">
               <span className='icons'> <img src={Images.Game} alt="" /> </span>
            </div>
            <div className="cont-rec">
                <h2>Game <br/> Developer.</h2>
                <span>5+ Projects</span>
            </div>
        </div>
        </div>
        
    </div>
  )
}

export default Service